export enum ErrorReasons {
  USER_NOT_CONFIRMED = 'UserNotConfirmed',
  USER_ALREADY_IN_COMPANY = 'UserAlreadyInCompany',
  PENDING_USER_INVITATION = 'PendingUserInvitation',
  INVALID_TOKEN = 'InvalidToken',
  ENCRYPTION_ERROR = 'EncryptionError',
  DECRYPTION_ERROR = 'DecryptionError',
  VALIDATION_ERROR = 'ValidationError',
  COMPANY_USER_ALREADY_EXISTS = 'CompanyUserAlreadyExists',
  INVALID_COMPANY_USER_STATUS = 'InvalidCompanyUserStatus',
  WORKSPACE_USER_ALREADY_EXISTS = 'WorkspaceUserAlreadyExists',
  WORKSPACE_NAME_OR_CODE_ALREADY_EXISTS = 'WorkspaceNameOrCodeAlreadyExists',
  WORKSPACE_USER_CANNOT_DELETE_LAST_ADMIN = 'WorkspacesUserCannotDeleteLastAdmin',
  ROLE_HAS_USERS = 'RoleHasUsers',
  CANNOT_DELETE_LAST_ADMIN = 'CannotDeleteLastAdmin',
  USER_CANNOT_BE_DELETED = 'UserCannotBeDeleted',
  MESSAGE_REJECTED = 'MessageRejected',
  LIMIT_EXCEEDED = 'LimitExceededException',

  // Assets Errors
  ASSET_DEFINITION_HAS_ASSETS = 'AssetDefinitionHasAssets',
  INVALID_SECURITY_CODE = 'InvalidSecurityCode',
  ASSET_NOT_FOUND_BY_ID = 'AssetNotFoundById',
  INVALID_TRANSFER_CODE = 'InvalidTransferCode',
  SECURITY_CODE_MISMATCH = 'SecurityCodeMismatch',
  CANNOT_ASSIMILATE_OWN_ASSET = 'CannotAssimilateOwnAsset',
  ASSET_OWNER_NOT_FOUND = 'AssetOwnerNotFound',
  TARGET_WORKSPACE_NOT_FOUND = 'TargetWorkspaceNotFound',
  TARGET_WORKSPACE_NOT_ACTIVE = 'TargetWorkspaceNotActive',
  ASSET_TRANSFER_FAILED = 'AssetTransferFailed',
  SECURITY_CODE_REGENERATION_FAILED = 'SecurityCodeRegenerationFailed',
  MALFORMED_XML = 'MalformedXml',
  ASSET_DEFINITION_NOT_FOUND = 'AssetDefinitionNotFound',
  XML_TEMPLATE_FETCH_FAILED = 'XmlTemplateFetchFailed',

  // SES Errors
  ACCOUNT_SENDING_PAUSED = 'AccountSendingPausedException',
  CONFIGURATION_SET_NOT_EXIST = 'ConfigurationSetDoesNotExistException',
  MAIL_FROM_DOMAIN_NOT_VERIFIED = 'MailFromDomainNotVerifiedException',
  SES_SERVICE_ERROR = 'SESServiceException'
}
